import { COOKIE_KEYS } from '@/constants/cookies';

export enum AuthForms {
  LOG_IN = 'login',
  SIGN_UP = 'sign-up',
  FORGOT_PASSWORD = 'forgot',
  RESET_PASSWORD = 'reset',
}

export enum AuthEndpoints {
  LOGIN = '/login',
  LOGOUT = '/logout',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
}

// ============== DTO ==============

export interface IAuthorizedRequestDTO {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  [COOKIE_KEYS.AUTH_TOKEN]?: string;
}

export interface ILoginDTO {
  email: string;
  password: string;
}

export interface IForgotPasswordDTO {
  email: string;
}

export interface IResetPasswordDTO {
  token: string;
  email: string;
  password: string;
}

// ============== Response ==============

export interface IAuthResponse {
  data: {
    access_token: string;
  };
}
